module.exports = __webpack_public_path__ + "img/galerie_preview-400x300.c640a737.jpg";